module.exports = __webpack_public_path__ + "img/idea_img5.ade386ac.png";